/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
/*------------------------------------*\
    Calendat
\*------------------------------------*/
class RaceCalendar {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let prevBtnFlat = document.getElementById('prevBtnFlat');
        let nextBtnFlat = document.getElementById('nextBtnFlat');
        let prevBtnJump = document.getElementById('prevBtnJump');
        let nextBtnJump = document.getElementById('nextBtnJump');

        let currentMonthFlat = $('.calendar__head--flat').find('.active');
        let currentMonthJump = $('.calendar__head--jump').find('.active');

        var idFlat = currentMonthFlat[0].id;
            idFlat = idFlat.replace('flat', '');

        var idJump = currentMonthJump[0].id;
            idJump = idJump.replace('jump', '');

        var minId = 0;
        var maxId = 23;

        prevBtnFlat.addEventListener('click', evt => {
            idFlat = Math.max(Number(idFlat) - 1, minId);

            if (idFlat >= minId) {
                $('.calendar__head--flat').find('.active').removeClass('active');
                $('.calendar__body--flat').find('.active').removeClass('active');

                document.getElementById('flat'+idFlat).classList.toggle('active');
                document.getElementById('flatCalendarBody'+idFlat).classList.toggle('active');
            }
        });

        nextBtnFlat.addEventListener('click', evt => {
            idFlat = Math.min(Number(idFlat) + 1, maxId);

            if (idFlat <= maxId) {
                $('.calendar__head--flat').find('.active').removeClass('active');
                $('.calendar__body--flat').find('.active').removeClass('active');

                document.getElementById('flat'+idFlat).classList.toggle('active');
                document.getElementById('flatCalendarBody'+idFlat).classList.toggle('active');
            }
        });

        prevBtnJump.addEventListener('click', evt => {
            idJump = Math.max(Number(idJump) - 1, minId);

            if (idJump >= minId) {
                $('.calendar__head--jump').find('.active').removeClass('active');
                $('.calendar__body--jump').find('.active').removeClass('active');

                document.getElementById('jump'+idJump).classList.toggle('active');
                document.getElementById('jumpCalendarBody'+idJump).classList.toggle('active');
            }
        });

        nextBtnJump.addEventListener('click', evt => {
            idJump = Math.min(Number(idJump) + 1, maxId);

            if (idJump <= maxId) {
                $('.calendar__head--jump').find('.active').removeClass('active');
                $('.calendar__body--jump').find('.active').removeClass('active');

                document.getElementById('jump'+idJump).classList.toggle('active');
                document.getElementById('jumpCalendarBody'+idJump).classList.toggle('active');
            }
        });
    }
}

export default RaceCalendar;
